import React from "react";
import styled from 'styled-components';
import TellySpace from '../../../images/telly-space.png';

const ModalBackground = styled.div`
	background-color: rgba(0,0,0, .6);
	height: 100%;
	width: 100%;
	position: fixed; 
	top: 0;
	left: 0;
	z-index: 100;
    display: flex;
`;

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    // background-color: white;
    border-radius: 10px;
    width: 803px;
    height: 600px;
    flex-shrink: 0;
    border-radius: 24px;
    margin: auto;
    padding: 62px;
    background: #121114;
`;

const TellySpaceImage = styled.img`
    width: 269px;
    height: 308px;
`;

const ModalTitle = styled.h2`
    margin: 20px 0 8px 0;
    background: linear-gradient(109deg, #FF6AE6 -4.67%, #FFF85C 69.07%, #A6FF79 120.95%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

const ModalText = styled.h6`
    margin: 0 0 24px 0;
    color: #FFF;
`;

const ModalLink = styled.a`
    border-radius: 100px;
    border: 1px solid #BFBBCF;
    padding: 12px 20px;
    color: #E5E4EC;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Poppins;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    &:hover,
    &:focus {
        color: #E5E4EC;
        background-color: #625E70;
    }
`;

const helpLink = 'https://help.brand.live/hc/en-us/articles/5084985572759-How-to-Troubleshoot-Camera-and-Microphone';

export default function DevicePermission() {
    return (
        <ModalBackground>
            <ModalContainer>
                <TellySpaceImage alt={'Telly Space'} src={TellySpace} />
                <ModalTitle className="bl-font-header">Click "Allow"</ModalTitle>
                <ModalText className="bl-font-header">We need permission to access your cam & mic</ModalText>
                <ModalLink href={helpLink} target="_blank">I don't see the button</ModalLink>
            </ModalContainer>
        </ModalBackground>
    );
}